import { Component, OnInit, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import { Router } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from '@irb/app.service';
import { PageService } from '@irb-common/services/page.service'; 
import { IrbDashboardService } from '@irb/irb-dashboard/irb-dashboard.service';
import { IClientDetails } from '@irb/irb-dashboard/irb-dashboard.model';
import { IrbCreatePortfolioEvents } from '@irb-common/events';
import { IApplyFilterOnLanding } from '@irb/app.model';
import { AnalyticsService } from '@irb/irb-common/analytics/analytics.service';

@Component({ standalone: false,
  selector: 'irb-com-clients',
  templateUrl: './com-clients.component.html',
  styleUrls: ['./com-clients.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ComClientsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  loadedPf: boolean;
  loadedUnassigned: boolean;
  loadedPfWithHP: boolean;
  loadedPfPending: boolean;
  loadedTax: boolean;
  data: any = {
    "totalPortfolioValue": null,
    "totalPortfolio": null,
    "highPriorityNoteCount": null,
    "unassignedAccountCount": null,
    "taxHarExpCount": null,
    "unassignedAccountValue": null,
    "portPendingResultsCount": null
}
  constructor(
    public as: AppService,
    public ps: PageService, 
    private dbs: IrbDashboardService,
    private router: Router,
    private ats: AnalyticsService
  ) {}

  ngOnInit() {
    this.ps.getUserDetails().pipe(takeUntil(this.destroyed$)).subscribe((d) => {
      if(d) {
        // this.dbs.getClientDetails().pipe(takeUntil(this.destroyed$)).subscribe((d) => {
        //   this.data = d as IClientDetails;
        // });
        this.dbs.getPfValueDetails().pipe(takeUntil(this.destroyed$)).subscribe((d: any) => {
          this.loadedPf=true;
          this.data.totalPortfolioValue = d.totalPortfolioValue;
          this.data.totalPortfolio = d.totalPortfolio;
        });
        this.dbs.getUnassignAccValueDetails().pipe(takeUntil(this.destroyed$)).subscribe((d: any) => {
          this.loadedUnassigned=true;
          this.data.unassignedAccountCount = d.unassignedAccountCount;
          this.data.unassignedAccountValue = d.unassignedAccountValue;
        });
        this.dbs.getPfWithHPNotesCount().pipe(takeUntil(this.destroyed$)).subscribe((d: any) => {
          this.loadedPfWithHP=true;
          this.data.highPriorityNoteCount = d.highPriorityNoteCount;
        });
        this.dbs.getPfPendingResultCount().pipe(takeUntil(this.destroyed$)).subscribe((d: any) => {
          this.loadedPfPending=true;
          this.data.portPendingResultsCount = d.portPendingResultsCount;
        });
        this.dbs.gettaxHarExpCount().pipe(takeUntil(this.destroyed$)).subscribe((d: any) => {
          this.loadedTax=true;
          this.data.taxHarExpCount = d.taxHarExpCount;
        });
      }
    });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  showCreatePortfolio() {
    this.ats.trackClickEvent("md_createport");
    this.as.fireEvent(IrbCreatePortfolioEvents.SHOW_CREATE_PORTFOLIO);
  }

  showPortfoliosWithPendingResults() {

    const state:IApplyFilterOnLanding = {
      isUpdatRequired : true,
      filterModel : {name:'pendingResults', value:['Yes'], isUpdatRequired:true}
    } as IApplyFilterOnLanding;

    this.router.navigateByUrl('/clients/portfolios', { state: state });
  }

  showTaxHarvestExpiration() {
    const state:IApplyFilterOnLanding = {
      isUpdatRequired : true,
      filterModel : {name:'taxlossResults', value:['Yes'], isUpdatRequired:true}
    } as IApplyFilterOnLanding;

    this.router.navigateByUrl('/clients/portfolios', { state: state });
  }

  showUnassignedAccounts() {
    this.ats.trackPassiveEvent("lc_unacct");
    this.router.navigate(['/clients/unassigned-accounts']);
  }
  
  showPortfolios() {
    this.ats.trackPassiveEvent("lc_clients");
    this.router.navigate(['/clients/portfolios']);
  }

}
